import { useCallback, useState } from "react"
import { useAppContext } from "~/app.use-app-context.hook"
import {
  isLoading,
  match,
  withFailure,
  withSuccess,
} from "~/store/async-store.utils"
import { Label } from "./label.model"

type State = {
  labels: Label[]
  isLoading: boolean
  error: string | null
}

export const useLabelsStore = () => {
  const {
    labelsModule: { service, store },
  } = useAppContext()
  const [state, setState] = useState<State>({
    labels: withSuccess(store.state, [], ({ labels }) => labels),
    isLoading: isLoading(store.state),
    error: withFailure(store.state, null, (error) => error),
  })

  store.addListener(
    match({
      onInitial: () => {
        setState({
          labels: [],
          isLoading: false,
          error: null,
        })
      },
      onLoading: () => {
        setState({ ...state, isLoading: true })
      },
      onFailure: (error) => {
        setState({ ...state, error, isLoading: false })
      },
      onSuccess: ({ labels }) => {
        setState({ labels, isLoading: false, error: null })
      },
    }),
  )

  const fetchLabels = useCallback(async () => {
    await service.fetchAll()
  }, [service])

  return {
    state,
    actions: { fetchLabels },
  }
}
